import React, { useState } from "react";
import { Navigate } from "react-router-dom";

import { Btn, Field } from "../components/wf";
import { logoUrl } from "../lib/api";
import { useAuth } from "../lib/auth";
import { DEFAULT_NAME, useBranding } from "../lib/queries";

export default function Login() {
  const { user, login } = useAuth();
  const branding = useBranding();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (!email || !password) return setError("Enter your email and password");
    setBusy(true);
    setError("");
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(err.message ?? "Login failed");
    } finally {
      setBusy(false);
    }
  };
  const b = branding.data;

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden flex-col justify-between overflow-hidden bg-wf-brand p-14 text-wf-onbrand lg:flex">
        <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-white/10" />
        <div className="absolute -bottom-32 -left-20 h-[28rem] w-[28rem] rounded-full bg-black/10" />
        <div className="relative flex items-center gap-3">
          <img src="/forgeops-192.png" alt="ForgeOps" data-testid="login-forgeops-icon" className="h-12 w-12 rounded-xl shadow-lg" />
          <p className="text-sm font-bold uppercase tracking-[0.2em] opacity-80">ForgeOps</p>
        </div>
        <div className="relative">
          <h2 className="text-5xl font-extrabold leading-[1.05] tracking-tight">Jobs, crews and hours.<br />Now on the big screen.</h2>
          <p className="mt-4 max-w-md text-lg opacity-85">Same accounts and the same live data as the mobile app.</p>
        </div>
        <p className="relative text-sm opacity-70">Accounts are created by an admin in Settings.</p>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="wf-rise w-full max-w-sm" data-testid="login-form">
          <img
            src={b?.has_logo ? logoUrl(b) : "/forgeops-icon.png"}
            alt="ForgeOps"
            data-testid="login-logo"
            className="mb-6 h-24 w-24 rounded-3xl border border-wf-line object-cover"
          />
          <h1 data-testid="login-company-name" className="text-4xl font-extrabold tracking-tight">{b?.company_name || DEFAULT_NAME}</h1>
          <p className="mb-8 mt-1.5 text-wf-mute">Sign in to manage jobs, crews and hours.</p>
          <Field label="Email" testid="login-email-input" type="email" autoComplete="email" value={email} onChange={setEmail} placeholder="you@company.com" />
          <Field label="Password" testid="login-password-input" type="password" autoComplete="current-password" value={password} onChange={setPassword} placeholder="Password" />
          {error && <p data-testid="login-error-text" className="mb-3 text-sm font-medium text-wf-err">{error}</p>}
          <Btn type="submit" loading={busy} className="w-full" data-testid="login-submit-button">Sign In</Btn>
          <p className="mt-4 text-center text-sm text-wf-mute lg:hidden">Accounts are created by an admin in Settings.</p>
        </form>
      </div>
    </div>
  );
}
